import React, { Suspense } from 'react'

import { match as Match } from 'react-router-dom';

import type { RouteParams } from './FilePreviewPage';

type Props = {
  match: Match<RouteParams>
}

const FilePreviewPage = React.lazy(() => import('./FilePreviewPage'))

export default ({ match }: Props) => (
  <Suspense fallback={<div />}>
    <FilePreviewPage match={match} />
  </Suspense>
)
